import { connect } from 'react-redux';

import config from '@config';
import {
  setDetailPanelTarget,
  hideDetailPanel,
  clearDetailPanel,
  bypassDetailPanel,
} from '@store/actions/ux';
import { updateProgram } from '@store/actions/programs';
import {
  requestProgramDetailsSimple,
  requestProgramMoreEpisodes,
} from '@tvguide/store/actions/requests';
import DetailPanel from './detailpanel';

const mapStateToProps = (state, ownProps) => {
  let channel = null;
  let program = null;
  let related = null;

  state.channels.some(c => {
    const targetProgram = c.programs.find(
      p => p.uuid == state.ux.detailPanel.id,
    );

    if (targetProgram) {
      channel = c;
      program = targetProgram;

      related = c.programs.filter(p => {
        return program && program.related && program.related.includes(p.uuid);
      });
    }

    return !!targetProgram;
  });

  return {
    bypass: state.ux.detailPanel.bypass,
    display: state.ux.detailPanel.display,
    nid: state.ux.nid,
    program: program,
    relatedPrograms: related,
    channel: channel,
  };
};

const mapDispatchToPros = dispatch => ({
  closePanel: () => {
    dispatch(hideDetailPanel());
    setTimeout(() => {
      dispatch(clearDetailPanel());
    }, config.detailPanelTransitionDuration);
  },
  getMoreEpisodes: (sid, nid, id, pid) => {
    dispatch(
      updateProgram(sid, id, {
        requesting: true,
      }),
    );
    dispatch(requestProgramMoreEpisodes(sid, nid, id, pid));
  },
  displayProgramDetails: (sid, id, pid) => {
    dispatch(requestProgramDetailsSimple(id, sid, pid));
    dispatch(setDetailPanelTarget(id));
  },
  bypassOpening: () => {
    dispatch(bypassDetailPanel());
  },
});

export default connect(mapStateToProps, mapDispatchToPros)(DetailPanel);
